"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _theme = require("HubStyleTokens/theme");

var _times = require("HubStyleTokens/times");

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("UIComponents/decorators/Controllable"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIHoverlay = _interopRequireDefault(require("UIComponents/overlay/UIHoverlay"));

var _UIBreakString = _interopRequireDefault(require("UIComponents/text/UIBreakString"));

var _HoverProvider = _interopRequireDefault(require("UIComponents/providers/HoverProvider"));

var _ActiveProvider = _interopRequireDefault(require("UIComponents/providers/ActiveProvider"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _Price = _interopRequireDefault(require("./Price"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    &.is--selectable {\n      cursor: pointer;\n      border: 2px solid transparent;\n      transition: border ", " ease-out;\n\n      &.is--hovered {\n        border-color: ", ";\n        box-shadow: 0 0 12px 0 ", ";\n      }\n\n      &.is--selected {\n        background-color: ", ";\n        border-color: ", ";\n      }\n\n      &.is--disabled {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: none;\n        color: ", " !important;\n        cursor: not-allowed;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var iconMaxHeight = 48;
var StyledUICardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "AbstractCard__StyledUICardWrapper",
  componentId: "sc-11oxu65-0"
})(_templateObject(), _times.MICRO_TRANSITION_TIMING, _colors.CALYPSO_MEDIUM, _theme.SELECTABLE_BOX_SHADOW_COLOR, _theme.SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR, _theme.SELECTABLE_BOX_SELECTED_BORDER_COLOR, _theme.BUTTON_DISABLED_BACKGROUND_COLOR, _theme.BUTTON_DISABLED_BACKGROUND_COLOR, _colors.BUTTON_DISABLED_TEXT);

var DefaultFooter = function DefaultFooter(_ref) {
  var installs = _ref.installs,
      price = _ref.price;
  return _react.default.createElement(_Footer.default, null, _react.default.createElement(_Small.default, {
    use: "help"
  }, installs), _react.default.createElement(_Price.default, {
    value: price
  }));
};

var DefaultHeader = function DefaultHeader(_ref2) {
  var title = _ref2.title;
  return _react.default.createElement(_H.default, {
    className: "m-bottom-0"
  }, title);
};

var AbstractCard = function AbstractCard(props) {
  var bodyComponent = props.bodyComponent,
      className = props.className,
      disabled = props.disabled,
      footerComponent = props.footerComponent,
      footerHoverlayContent = props.footerHoverlayContent,
      headingComponent = props.headingComponent,
      iconUrl = props.iconUrl,
      imageSectionClassName = props.imageSectionClassName,
      installs = props.installs,
      onClick = props.onClick,
      onSelectedChange = props.onSelectedChange,
      price = props.price,
      ribbonComponent = props.ribbonComponent,
      selectable = props.selectable,
      selected = props.selected,
      statusComponent = props.statusComponent,
      subtitle = props.subtitle,
      title = props.title,
      titleHelpText = props.titleHelpText;
  var handleClick = (0, _react.useCallback)(function (event) {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (selectable) {
      onSelectedChange((0, _SyntheticEvent.default)(!selected));
    }

    if (onClick) onClick(event);
  }, [disabled, onClick, onSelectedChange, selectable, selected]);
  return _react.default.createElement(_HoverProvider.default, props, function (hoverProviderProps) {
    return _react.default.createElement(_ActiveProvider.default, props, function (activeProviderProps) {
      var active = activeProviderProps.active,
          activeProviderRestProps = (0, _objectWithoutProperties2.default)(activeProviderProps, ["active"]);
      var hovered = hoverProviderProps.hovered,
          hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
      var computedClassName = (0, _classnames.default)(className, {
        'is--active': active,
        'is--disabled': disabled,
        'is--hovered': hovered,
        'is--selectable': selectable,
        'is--selected': selected
      });

      var renderedFooter = _react.default.createElement(_UICardSection.default, {
        className: "p-top-5"
      }, CustomRenderer.render(footerComponent, {
        installs: installs,
        price: price
      }));

      if (footerHoverlayContent) {
        renderedFooter = _react.default.createElement(_UIHoverlay.default, {
          foregroundContent: _react.default.createElement(_UIFlex.default, {
            align: "center",
            justify: "center"
          }, footerHoverlayContent),
          hovered: hovered,
          use: "bottom-half-card"
        }, renderedFooter);
      }

      var renderedBody = bodyComponent ? CustomRenderer.render(bodyComponent) : null;
      return _react.default.createElement(StyledUICardWrapper, (0, _extends2.default)({}, activeProviderRestProps, hoverProviderRestProps, {
        "aria-checked": selected,
        "aria-disabled": disabled,
        className: computedClassName,
        compact: true,
        onClick: handleClick
      }), ribbonComponent && CustomRenderer.render(ribbonComponent), _react.default.createElement(_UICardSection.default, {
        className: (0, _classnames.default)(imageSectionClassName, 'p-bottom-4')
      }, _react.default.createElement(_UIFlex.default, {
        justify: "between"
      }, _react.default.createElement(_UIImage.default, {
        src: iconUrl,
        style: {
          maxHeight: iconMaxHeight
        }
      }), statusComponent && CustomRenderer.render(statusComponent))), _react.default.createElement(_UICardSection.default, {
        className: "p-bottom-0",
        scrollable: true
      }, _react.default.createElement("div", {
        className: "m-bottom-2"
      }, _react.default.createElement(_UIBreakString.default, null, CustomRenderer.render(headingComponent, {
        title: title
      })), titleHelpText && _react.default.createElement(_Small.default, {
        use: "help"
      }, titleHelpText)), subtitle && _react.default.createElement("p", null, subtitle)), renderedBody, renderedFooter);
    });
  });
};

AbstractCard.propTypes = {
  bodyComponent: CustomRenderer.propType,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  footerComponent: CustomRenderer.propType,
  footerHoverlayContent: _propTypes.default.node,
  headingComponent: CustomRenderer.propType,
  iconUrl: _propTypes.default.string.isRequired,
  imageSectionClassName: _propTypes.default.string,
  installs: _propTypes.default.number,
  onClick: _propTypes.default.func,
  onSelectedChange: _propTypes.default.func,
  price: _propTypes.default.number,
  ribbonComponent: CustomRenderer.propType,
  selectable: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  statusComponent: CustomRenderer.propType,
  subtitle: _propTypes.default.node,
  title: _propTypes.default.node,
  titleHelpText: _propTypes.default.node
};
AbstractCard.defaultProps = {
  disabled: false,
  headingComponent: DefaultHeader,
  selectable: false,
  selected: false,
  footerComponent: DefaultFooter
};

var _default = (0, _Controllable.default)(AbstractCard, ['selected']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/cards/AbstractCard.js
// module id = 883
// module chunks = 209 210 211 212